module.exports = __webpack_public_path__ + "static/media/venue_jiu02.9f2d4eca.jpg";